<template>
    <div class="t-userItem">
        <div v-if="user.new" class="t-userItem__new"></div>
        <div class="t-userItem__img">
            <slot name="img">
                <img v-if="user.img !== ''" :src="user.img">
                <img v-else src="/img/default_img.png">
            </slot>
        </div>
        <div class="t-userItem__name" :class="{ _blue: user.online || user.isAdmin}">
            <slot name="name">
                {{ user.name }}
            </slot>
        </div>
        <slot name="info">
        </slot>
        <!-- <div class="t-userItem__date">{{ user.lastActiveDate }}</div> -->
    </div>
</template>

<script>
    export default {
        data(){
            return {}
        },
        props: ['user']
    }
</script>

<style lang="sass">
.t-userItem
    width: 100%
    padding: 12px 8px
    border-radius: 8px
    cursor: pointer
    display: flex
    align-items: center
    position: relative
    &__wrapper
        display: block
        padding: 12px 8px
        border-radius: 8px
        position: relative
        .t-userItem
            // padding: 0
            margin: -12px -8px
        &:not(:first-child)
            &:before
                content: ''
                position: absolute
                top: 0
                left: 8px
                right: 8px
                height: 1px
                background: $input
    &__new
        position: absolute
        top: 5px
        left: 0
        width: 20px
        height: 20px
        border-radius: 50%
        background: $accented
    &__img
        width: 50px
        height: 50px
        border-radius: 8px
        overflow: hidden
        margin-right: 12px
        flex: none
        img
            width: 100%
            height: 100%
            object-fit: cover
    &__name
        font-size: 14px
        font-weight: bold
        line-height: 1.2
        flex: 1
        &._blue
            color: $blue
    &__date
        flex: none
        line-height: 1.2
        font-size: 12px
        align-self: flex-start
    &.router-link-exact-active
        background: $promo
        + .t-dialogItem:before
            content: none
            display: none
    &_admin
        order: -1
        background: $input
        &.router-link-exact-active
        background: $blue
        color: #ffffff
        .t-dialogItem__name
            color: #ffffff
        + .t-dialogItem:before
            content: none
            display: none
    &:not(.router-link-exact-active):not(:first-child)
        &:before
            content: ''
            position: absolute
            top: 0
            left: 8px
            right: 8px
            height: 1px
            background: $input
</style>


// WEBPACK FOOTER //
// src/vue_components/UserItem.vue